import { client } from "../client";
import { TicketLabel } from "../types/ticket.types";

export const createTicketLabel = async (label: TicketLabel) => {
	const response = await client.post<TicketLabel>(`tickets/labels`, label);
	return response.data;
};

export const deleteTicketLabel = async (id: number) => {
	const response = await client.delete<TicketLabel>(`tickets/labels/${id}`);
	return response.data;
};

export const updateTicketLabel = async ({
	id,
	...fields
}: Partial<TicketLabel>) => {
	const response = await client.patch<TicketLabel>(
		`tickets/labels/${id}`,
		fields,
	);
	return response.data;
};
